/* global globalThis */
import React, { /*useEffect,*/ useState } from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';

import { Ajax } from '../../../components/Ajax';
import { PopupTypes } from '../../../components/Popup';
import { DataTip, T } from '../../../components/Translations';
import { ApiUrl, AppPages } from '../../../project/Defines';
import { dispatchCustomEvent, EVENT_NAME } from '../../../project/utilities';
import ListView from '../../../Shared/ListView';
import { COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { hideLoader, showLoader } from '../../../Shared/Loader';

/**
 * Attachments list of serviceCall
 * @exports Attachments
 */
export default function Attachments(props) {
    const listUpdateEvent = EVENT_NAME.ATTACHMENTS_LIST_UPDATE;
    const { dataSource, setDataSource, disabled, isReadOnlyRole } = props;
    const isActionsDisabled = Boolean(disabled);
    const isNewCall = !!dataSource;
    const service_job_uuid = props.dataItem?.ID; 
    const [staticFilter] = useState({ service_job_uuid });
    const [detailProps] = useState({
        newTitle: 'text.create_new_attachment',
        editTitle: 'text.edit_attachment',
        fullScreen: false,
        popupType: PopupTypes.AttachmentDetails,
        windowKey: 'wndAttachmentDetails',
        parentData: props.dataItem || {},
        isNewCall,
        setDataSource
    });
    // const currentNetworkRole = (localStorage.getItem(StoreKeys.CurrentNetworkRole) || '').replace(/^"|"$/g, '').trim().toLowerCase();
    // const isReadOnlyRole = currentNetworkRole.includes('readonlyuser');

    const columnConfig = [
        {
            field: 'attachment_name',
            width: 50,
            render: (text, record) => {
                const url = record?.images?.[0]?.image_url;
                const imageName = record?.images?.[0]?.name && record?.images?.[0]?.image_guid;
                
                return (
                    <wrap>
                        <a /* eslint-disable-line jsx-a11y/anchor-is-valid */
                         onClick={() => {
                            //setRedirectUrl(url);
                            Ajax.get({
                                url: url + `&fileSecondName=${record?.attachment_name}`,
                                absolute: true,
                                // data: { 
                                // },
                                success: function (response) {
                                  if (response) {
                                    globalThis.open(response, '_blank');
                                  } else {
                                    message.error("Attachment not found.");
                                  }
                                },
                                error: function (error) {
                                    message.error("Attachment not found.");
                                }
                              });
                          }}
                         style={{ display: 'flex' }}><DataTip title={imageName}><icon>eye</icon></DataTip></a> 
                        {/* <a href={url} target='_blank' style={{ display: 'flex' }}><DataTip title={imageName}><icon>eye</icon></DataTip></a> eslint-disable-line react/jsx-no-target-blank*/}
                    </wrap>
                );
            },

            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.attachment_name',
            field: 'attachment_name',
            type: COLUMN_TYPE.TEXT
        },
        !isReadOnlyRole ? {
            type: COLUMN_TYPE.ACTION,
        } : {},
        // {
        //     text: 'text.file',
        //     key: 'file',
        //     width: 160,
        //     noSort: true,
        //     type: COLUMN_TYPE.TEXT,
        //     render: (text, record) => (
        //         <>
        //             <wrap>
        //                 <div style={{
        //                     backgroundImage: "Url(" + record.image_url + ")",
        //                     backgroundRepeat: "no-repeat",
        //                     backgroundSize: "contain",
        //                     backgroundPosition: "center",
        //                     height: "35px"
        //                 }} />
        //             </wrap>
        //         </>
        //     )
        // },

    ];

    const generateWarrantyCertificate = () => {
        const loaderName = 'generateWarrantyCertificate';
        showLoader(loaderName);
        Ajax.post({
            url: ApiUrl.GenerateWarrantyCertificate,
            data: { service_job_uuid },
            success: function (response) {
                if (response) {
                    dispatchCustomEvent(listUpdateEvent);
                }
                hideLoader(loaderName);
            },
            error: function (response) {
                if (response.message) {
                    message.error(response.message);
                }
                hideLoader(loaderName);
            }
        });
    };

    const generateAssignmentReport = () => {
        const loaderName = 'generateAssignmentReport';
        showLoader(loaderName);
        Ajax.post({
            url: ApiUrl.GenerateAssignmentReport,
            data: { service_job_uuid },
            success: function (response) {
                if (response) {
                    dispatchCustomEvent(listUpdateEvent);
                }
                hideLoader(loaderName);
            },
            error: function (response) {
                if (response.message) {
                    message.error(response.message);
                }
                hideLoader(loaderName);
            }
        });
    };

    return (<>
        {(isReadOnlyRole || !isNewCall) && < toolbar >
            <div 
               className={`button accent ${isActionsDisabled ? 'disabled' : ''}`} 
               disabled={isActionsDisabled}
               onClick={generateWarrantyCertificate}
            >
                <text><T>text.warranty_certificate</T></text>
            </div>
            <button
                type='button'
                className={`button accent ${isActionsDisabled ? 'disabled' : ''}`}
                disabled={isActionsDisabled}
                onClick={generateAssignmentReport}
            >
                <text><T>text.assignment_report</T></text>
            </button>
        </toolbar>}
        <ListView
            {...props}
            columnConfig={columnConfig}
            staticFilter={staticFilter}
            apiUrl={ApiUrl.AttachmentsList}
            dataSource={dataSource}
            skipEdit
            listUpdateEvent={listUpdateEvent}
            detailProps={detailProps}
            deleteUrl={!disabled && ApiUrl.AttachmentsDelete}
            skipNewButton={disabled}
            onCustomDelete={isNewCall ? (rec => setDataSource(d => d.filter(at => at.ID !== rec.ID))) : undefined}
            newButtonTip={<T>text.create_new_attachment</T>}
            nameField='attachment_name'
            showRefreshButton={false}
            isSimple
            isChieldView
            listName={AppPages.Attachments}
        /></>

    );
}

Attachments.propTypes = {
    dataSource: PropTypes.array,
    setDataSource: PropTypes.func,
    disabled: PropTypes.bool,
    dataItem: PropTypes.object
};
